import React from 'react'
import { Link } from "react-router-dom";
import { FaCheck } from "react-icons/fa";

const stats = [
    ["89856+", "Working Hours"],
    ["31+", "Ongoing contracts"],
    ["10000+", "Finished projects"],
    ["26+", "Years in business"],
];

const sections = [
    {
        title: "World-Class Custom Machining and Project Management Services",
        body: [
            "Established in 1996 by owners Aurel Nistor and Valentin Dinoiu as a small, traditional machine shop, Cedonia has grown into a leading force in custom machining and project management. Over the years, we've evolved with the times-expanding our capabilities and investing in advanced technology to meet the ever-changing needs of our clients.",
            "Today, we are a trusted partner to a diverse, multi-industry client base that spans automotive, aerospace, nuclear, military, pharmaceutical, mining, and construction sectors. Our machining capabilities and technical expertise allow us to manufacture complex prototypes, parts, and sub-assemblies while:",
            "Our mission is to continuously advance our skills and technology so we can stay ahead of industry demands and exceed the expectations of every customer we serve.",
        ],
        bullets: ["Meeting strict precision standards", "Surpassing quality expectations and turnaround times", "Remaining cost-effective and competitive"],
    },
    {
        title: "Our Team - Knowledge, Skill, Experience, and a Desire to Help You Succeed",
        body: [
            "At Cedonia, our team is not just skilled and knowledgeable, but also friendly and customer-focussed. Whether you need advice on optimal design selection, or guidance on technical specifications, our expert professionals will be happy to offer their input and simplify your requirements.",
            "Over the years, our leaders Aurel & Valentin have built a small team of talented individuals with:",
        ],
        bullets: ["Extremely strong technical backgrounds", "A desire to continually upskill and stay ahead of the pack", "Passion to partner with clients and help them be successful", "Over 240 years of combined experience stretching over three continents"],
    },
    {
        title: "CNC Machining Capabilities and Project Management for Your Business",
        body: [
            "In addition to our technical expertise, our machine capabilities and quality control mechanisms are the fundamental pillars that help us fulfill diverse, machining, tooling and custom project requirements. When it comes to made-to-order tools and components, we remain the vendor of choice for our core clients, while expanding our horizons to serve new industries.",
            "Here at Cedonia, we are all about high precision, high quality products, superior technical skills, professional service, compressed delivery times, and competitive prices.",
        ],
    },
];

export default function About() {
    return (
        <div className='bg-zinc-50 text-zinc-900'>
            <section className="bg-white px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
                <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
                    <div>
                        <p className='text-sm font-semibold uppercase tracking-[0.24em] text-red-600'>About Cedonia</p>
                        <h1 className="mt-4 text-5xl font-extrabold tracking-tight text-zinc-950 sm:text-6xl">
                            Custom machining built on experience.
                        </h1>
                        <p className='mt-5 max-w-2xl text-lg leading-8 text-zinc-600'>
                            Based in Ontario, Canada, Cedonia has been serving multi-industry custom machining and project management clients since 1996.
                        </p>
                    </div>
                    <div className="rounded-lg border border-zinc-200 bg-zinc-50 p-6 shadow-xl shadow-zinc-900/5 sm:p-8">
                        <h2 className="text-3xl font-bold tracking-tight text-zinc-950">Get your quote today.</h2>
                        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                            <Link
                                to="/contact"
                                className="inline-flex items-center justify-center rounded-md bg-red-600 px-6 py-3 text-base font-semibold text-white shadow-sm shadow-red-900/10 transition duration-200 hover:-translate-y-0.5 hover:bg-red-700 hover:shadow-lg hover:shadow-red-900/15"
                            >
                                Quote
                            </Link>
                            <Link
                                to="/quality"
                                className="inline-flex items-center justify-center rounded-md border border-zinc-300 bg-white px-6 py-3 text-base font-semibold text-zinc-900 transition duration-200 hover:-translate-y-0.5 hover:border-red-200 hover:text-red-600 hover:shadow-lg hover:shadow-zinc-900/5"
                            >
                                Quality
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-zinc-950 px-4 py-12 text-white sm:px-6 lg:px-8">
                <div className="mx-auto grid max-w-7xl grid-cols-2 gap-4 text-center md:grid-cols-4">
                    {stats.map(([value, label]) => (
                        <div className='rounded-lg border border-white/10 bg-white/5 p-6' key={label}>
                            <h2 className="text-4xl font-bold tracking-tight sm:text-5xl">{value}</h2>
                            <p className="mt-2 text-xs font-semibold uppercase tracking-[0.18em] text-red-400">{label}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className='px-4 py-12 sm:px-6 lg:px-8 lg:py-16'>
                <div className='mx-auto grid max-w-7xl gap-5'>
                    {sections.map((section, index) => (
                        <article className='rounded-lg border border-zinc-200 bg-white p-6 shadow-sm sm:p-8 lg:p-10' key={section.title}>
                            <div className='grid gap-6 lg:grid-cols-[0.42fr_0.58fr]'>
                                <div>
                                    <p className='text-sm font-semibold uppercase tracking-[0.18em] text-red-600'>0{index + 1}</p>
                                    <h2 className='mt-3 text-3xl font-bold tracking-tight text-zinc-950'>{section.title}</h2>
                                </div>
                                <div className='space-y-5'>
                                    {section.body.map((paragraph) => (
                                        <p className='text-base leading-8 text-zinc-600' key={paragraph}>{paragraph}</p>
                                    ))}
                                    {section.bullets && (
                                        <div className='grid gap-3 sm:grid-cols-2'>
                                            {section.bullets.map((bullet) => (
                                                <p className='rounded-md bg-zinc-50 px-4 py-3 text-sm font-semibold leading-6 text-zinc-800' key={bullet}>
                                                    <FaCheck className='mr-2 inline-block text-red-600' size={"0.85em"} />{bullet}
                                                </p>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            <section className="bg-zinc-950 px-4 py-12 text-white sm:px-6 lg:px-8 lg:py-16">
                <div className="mx-auto flex max-w-7xl flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
                    <div>
                        <h2 className="text-3xl font-extrabold tracking-tight">See our services and contact us for any furtur inquiries.</h2>
                        <p className="mt-3 max-w-3xl text-lg leading-8 text-zinc-300">If you are confused about anything on the website feel free to contact us!</p>
                    </div>
                    <Link to="/services" className="inline-flex items-center justify-center rounded-md bg-red-600 px-6 py-3 text-base font-semibold text-white shadow-sm shadow-red-900/10 transition duration-200 hover:-translate-y-0.5 hover:bg-red-700 hover:shadow-lg hover:shadow-red-900/15">
                        Services
                    </Link>
                </div>
            </section>
        </div>
    )
}
